<template>
    <v-dialog
    v-model="dialog"                
    max-width="850px"
    :retain-focus="false"
    persistent
    >        
        <v-card>
            <v-btn class="mx-2 btnleft" 
            :disabled="editedIndex-1 < 0"
            @click="save(true,previous)" 
            fab dark small color="primary">
                <v-icon dark>keyboard_arrow_left</v-icon>
            </v-btn>
            <v-btn class="mx-2 btnright" 
            :disabled="editedIndex+1 >= items.length"
            @click="save(true,next)" fab dark small color="primary">
                <v-icon dark>keyboard_arrow_right</v-icon>
            </v-btn>
            <v-card-title
            class="grey lighten-2"
            primary-title
            >
            <div>
                {{this.dialogData.title}}    <br> 
                <span class="grey--text">{{this.dialogData.code}}</span><span class="grey--text" v-if="editedItems[0].reference != ''"> <v-icon dark>mdi-barcode-scan</v-icon> - Cód barras: {{editedItems[0].reference}}</span> <br>
                <div v-if="editedItems[0].pvpr" style="display: inline-flex "><span class="grey--text bold-text">pvpr - {{editedItems[0].pvpr}}€ &nbsp;&nbsp;&nbsp;</span></div>
                <div v-if="editedItems[0].pvprm" style="display: inline-flex "><span class="grey--text bold-text">PVPMR - {{editedItems[0].pvprm}}€</span></div>
                <div v-if="/*($store.state.usuario.type == 'Comercial') &&*/ (editedItems[0].disponible <= 0) && (fechaEntrega!='')"><span class="grey--text bold-text">Fecha de entrega prevista - {{fechaEntrega}}</span></div>
                <v-btn v-if="$store.state.usuario.type == 'Comercial'" @click="availabilityListVisible = !availabilityListVisible;">
                    <v-icon class="grey--text">list</v-icon><span class="grey--text">Disponible: {{editedItems[0].disponible}} </span> <br>
                </v-btn>
                <v-btn v-if="$store.state.usuario.type == 'Cliente'" @click="availabilityListVisible = !availabilityListVisible;">
                    <v-icon class="grey--text">list</v-icon>
                        <span class="grey--text">Disponible: 
                            <v-icon v-if="totalAvailable > 0" class="available">done</v-icon> 
                            <v-icon v-else class="nostock">not_interested</v-icon>
                    </span> <br>
                </v-btn>
                <availabilityList v-if="availabilityListVisible"/>
            </div>                                             
            </v-card-title>                            
            <v-card-text>                                                                          
            <v-layout>
                <promocionesArticulo v-if="$store.state.appconfig.promociones"/>                
            </v-layout>
            <v-layout>
                <descuentosArticulo v-if="editedItems[0].descuentos && editedItems[0].descuentos.length != 0"/>
            </v-layout>
            </v-card-text>
            <v-img 
            :src="this.dialogData.picture" 
            :lazy-src="this.dialogData.pictureLazy"
            contain
            max-height="550px"
            >
            </v-img>

            <v-divider></v-divider>

            <v-card-text>
                <v-container grid-list-md pa-0>                         
                    <span v-if="sameNoItems.length">Nuevo</span>
                    <v-icon
                    v-if="editedItems[0].trackingEnabled"
                        medium
                        @click="addNew()"                        
                    >
                        add
                    </v-icon>
                    <ul>
                        <li v-for="error in errors" :key="error.id">
                            <v-alert :value="true" color="error" icon="warning"> {{ error.msg }}
                            </v-alert>      
                        </li>                  
                    </ul>
                    <!--span><v-alert v-if="errors.items.length != 0" :value="true" color="error" icon="warning">{{ errors[.first('dto')] }}</v-alert> </span>                   
                    <span><v-alert v-if="errors.items.length != 0" :value="true" color="error" icon="warning">{{ errors.first('cantidad') }}</v-alert> </span>                   
                    <span><v-alert v-if="errors.items.length != 0" :value="true" color="error" icon="warning">{{ errors.first('precio') }}</v-alert> </span-->
                    <v-layout 
                    v-for="(editedItem, index) in editedItems"
                    :key="'new'+editedItem.no+index"
                    wrap>                                             
                        <v-flex xs6 sm3 md3>
                            <v-text-field v-model="editedItem.cantidad" type="number" label="Cantidad" @focus.stop="$event.target.select()" v-validate="'min_value:0'" name="cantidad"></v-text-field>                        
                        </v-flex>                        
                        <v-flex xs6 sm2 md2
                        v-if="$store.state.appconfig.allowUOMS" >
                            <v-select
                                :items="editedItem.uoms"
                                item-text="code"
                                item-value="code"
                                label="UD"
                                v-model="editedItem.uom"
                            ></v-select>
                        </v-flex>   
                        <v-flex xs6 sm2 md2
                        v-if="editedItem.trackingEnabled" >
                            <v-select
                                :items="editedItem.lotes"
                                :item-text="loteCaption"
                                item-value="lote"
                                label="Lote"
                                v-model="editedItem.lote"
                            ></v-select>
                        </v-flex>  
                        <v-flex xs6 sm2 md2 v-if="$store.state.usuario.editPrices">
                            <v-text-field v-model="editedItem.precio" type="number" label="Precio" @focus.stop="$event.target.select()" @change="editedItem.precioEditado = true" v-validate="'min_value:0'" name="precio"></v-text-field>                        
                        </v-flex>
                        <v-flex xs6 sm2 md2 v-if="!$store.state.usuario.editPrices">
                            <v-text-field v-model="editedItem.precio" type="number" label="Precio" v-validate="'min_value:0'" name="precio" readonly></v-text-field>                        
                        </v-flex>
                        <v-flex xs6 sm3 md3 v-if="$store.state.usuario.editPrices">
                            <v-text-field v-model="editedItem.descuento" type="number" label="Descuento" @focus.stop="$event.target.select()" v-validate="'max_value:100|min_value:0'" name="dto"></v-text-field>                        
                        </v-flex>   
                                                                 
                    </v-layout>  
                    <span v-if="sameNoItems.length">En pedido</span>                      
                    <v-layout 
                    v-for="(item, index) in sameNoItems"
                    :key="item.no+index"
                    wrap>
                        <v-flex xs6 sm4 md3>
                            <v-text-field v-model="item.cantidad" label="Cantidad" @focus="$event.target.select()" v-validate="'min_value:0'" name="cantidad"></v-text-field>                        
                        </v-flex>
                        <v-flex xs6 sm4 md3 v-if="$store.state.usuario.editPrices">
                            <v-text-field v-model="item.precio" type="number" label="Precio" @focus="$event.target.select()" @change="item.precioEditado = true" v-validate="'min_value:0'" name="precio"></v-text-field>                        
                        </v-flex>
                        <v-flex xs6 sm4 md3 v-if="$store.state.usuario.editPrices">
                            <v-text-field v-model="item.descuento" type="number" label="Descuento" @focus="$event.target.select()" v-validate="'max_value:100|min_value:0'" name="dto"></v-text-field>                        
                        </v-flex>
                        <v-flex xs5 sm3 md2>
                            <v-select
                                :items="item.lotes"
                                :item-text="loteCaption"
                                item-value="lote"
                                label="Lote"
                                v-model="item.lote"
                            ></v-select>
                        </v-flex>     
                        <v-flex xs1 sm1 md1>
                        <v-icon
                            small
                            right=""                            
                            @click="deleteItem(item)"
                        >
                            delete
                        </v-icon> 
                        </v-flex>                                        
                    </v-layout>               
                </v-container>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click="close">Cancelar</v-btn>
                <v-btn color="blue darken-1" flat @click="save(true,null)">Guardar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>   
</template>
<script>
import promocionesArticulo from '@/components/promocionesArticulo'
import descuentosArticulo from '@/components/descuentosArticulo'
import availabilityList from '@/components/availabilityList' 
export default {    
    name: 'dialogEditItem',
    components:{
        promocionesArticulo,
        descuentosArticulo,
        availabilityList
    },
    data: function () {
        return {
            fechaEntrega: '',
        }
    },
    methods:{
        /*imageLoadError (index) {
            console.log('Image failed to load');            
            var file = require('../assets/noimage.png');            
            this.dialogData.picture = file;
        },*/
        getExpectedReceiptDateLocal(item){    
            var thisaux = this;        
            this.fechaEntrega = '';
            var url = this.ApiBaseUrlNETCore + "items/getExpectedReceiptDate";                                    
            ////console.log(url);        
            this.axios.post(url,{no: item.no})
            .then(response => {      
                //console.log(response);
                if (response.data.length > 0){
                    var date_ = Date.parse(response.data);
                    var expectedDate = new Date(date_);
                    thisaux.fechaEntrega = expectedDate.toLocaleDateString();
                }
            })
            .catch(function (error) {
                // handle error
                console.log(error);                 
            })
            .finally(function () {                                                                            
            }); 
        },
        loteCaption(item){
            if(item.caducidad != ''){
                return item.lote + '(' + item.disponible + ') - ' + item.caducidad;
            } else {                
                return item.lote + '(' + item.disponible + ')';
            }            
        },  
        close () {
            if (this.editedItems[0].trackingEnabled){
                //Este codigo es para descartar los cambios en las lineas de pedido al darle a cerrar.
                //sameNoItems viene de una operacion .filter sobre un array, por lo que el tipo de copia es shallow copy,
                //actualizando los valores de sameNoItems se actualizan los valores en la lista de productos sin necesidad de 
                //codigo adicional.
                //Si la edicion se cancela, hay que restaurar los valores editados
                for (var i = 0; i < this.sameNoItems.length; i++){
                    this.sameNoItems[i].cantidad = this.sameNoItemsBackup[i].cantidad;
                    this.sameNoItems[i].precio = this.sameNoItemsBackup[i].precio;
                    this.sameNoItems[i].descuento = this.sameNoItemsBackup[i].descuento;
                    this.sameNoItems[i].lote = this.sameNoItemsBackup[i].lote;
                }
            }
            this.dialog = false        
        },
        save (closeDialog,callback) {      
            var ok = true;              
            //this.editedItem.lote = this.lotSelection;
            //Object.assign(this.items[this.editedIndex], this.editedItem);
            this.$validator.validate().then(valid => {
                if (!valid) {
                    ok = false;
                } else {
                    if (this.editedItems[0].trackingEnabled){    
                        for (var i = 0; i < this.editedItems.length; i++){            
                            if (!this.editedItems[i].lote){
                                if (this.editedItems[i].cantidad){
                                    this.setGlobalDialog('Lote requerido','No ha introducido lote para el producto ' + this.editedItems[i].no,false);
                                    return;
                                }
                            } else {
                                var resLote = this.editedItems[i].lotes.find(itm =>{
                                    return itm.lote == this.editedItems[i].lote;
                                });
                                if (resLote.length == undefined) resLote = [resLote];
                                //var orderQty = parseFloat(this.editedItems[i].cantidad);     
                                var orderQty = 0;
                                //Control de cantidad sobre lineas a insertar
                                var res = this.editedItems.filter(itm =>{
                                    return itm.lote == this.editedItems[i].lote;
                                });   
                                if (res != undefined) {
                                    if (res.length == undefined) res = [res];            
                                    for (var j = 0; j < res.length; j++){
                                        orderQty += parseFloat(res[j].cantidad);
                                    }
                                }
                                //Control de cantidad en otras lineas en pedido               
                                var res = this.sameNoItems.filter(itm =>{
                                    return itm.lote == this.editedItems[i].lote;
                                });        
                                if (res != undefined) {
                                    if (res.length == undefined) res = [res];            
                                    for (var j = 0; j < res.length; j++){
                                        orderQty += parseFloat(res[j].cantidad);
                                    }
                                }
                                if (parseFloat(resLote[0].disponible) < orderQty){
                                    this.setGlobalDialog('Exceso de cantidad', 'Se ha introducido mayor cantidad (' + orderQty + ') que la disponible para el lote ' + this.editedItems[i].lote + ' (' + resLote[0].disponible + ')',false);
                                    return;
                                }                    
                            }
                            if ((this.editedItems[i].precio == 0) && (this.editedItems[i].descuento != 100)){
                                this.setGlobalDialog('Línea sin precio', 'No se ha introducido precio para el producto ' + this.editedItems[i].no ,false);
                                return;
                            }
                            //this.items[this.editedIndex].cantidad = this.editedItem.cantidad;  
                            for (var i = 0; i < this.orderItems.length;){
                                if (this.orderItems[i].isPromo && (this.orderItems[i].fromitemNo == this.editedItems[i].no)){
                                    this.orderItems.splice(i, 1);
                                } else {
                                    i++;
                                }
                            }               
                            this.commitToCart(this.editedItems[i],true);
                        }
                        for (var i = 0; i < this.sameNoItems.length; i++){
                            if (!this.sameNoItems[i].lote) {
                                this.setGlobalDialog('Lote requerido','No ha introducido lote para el producto ' + this.sameNoItems[i].no,false);
                                return;
                            } else {
                                resLote = this.sameNoItems[i].lotes.find(itm =>{
                                    return itm.lote == this.sameNoItems[i].lote;
                                });
                                if (resLote.length == undefined) resLote = [resLote];
                                var orderQty = 0;      // Se inicializa a 0 porque el filter ya devuelve este mismo producto del bucle
                                //Control de cantidad sobre lineas a insertar
                                var res = this.editedItems.filter(itm =>{
                                    return itm.lote == this.sameNoItems[i].lote;
                                });   
                                if (res != undefined) {
                                    if (res.length == undefined) res = [res];            
                                    for (var j = 0; j < res.length; j++){
                                        orderQty += parseFloat(res[j].cantidad);
                                    }
                                }
                                //Control de cantidad en otras lineas               
                                var res = this.sameNoItems.filter(itm =>{
                                    return itm.lote == this.sameNoItems[i].lote;
                                });        
                                if (res != undefined) {
                                    if (res.length == undefined) res = [res];            
                                    for (var j = 0; j < res.length; j++){
                                        orderQty += parseFloat(res[j].cantidad);
                                    }
                                }
                                if (parseFloat(resLote[0].disponible) < orderQty){
                                    this.setGlobalDialog('Exceso de cantidad', 'Se ha introducido mayor cantidad (' + orderQty + ') que la disponible para el lote ' + this.sameNoItems[i].lote + ' (' + resLote[0].disponible + ')',false);
                                    return;
                                }
                            }
                            if ((this.sameNoItems[i].precio == 0) && (this.sameNoItems[i].descuento != 100)){
                                this.setGlobalDialog('Línea sin precio', 'No se ha introducido precio para el producto ' + this.sameNoItems[i].no ,false);
                                return;
                            }
                        }                                                                  
                    } else {            
                        this.items[this.editedIndex].cantidad = this.editedItems[0].cantidad;    
                        for (var i = 0; i < this.orderItems.length;){
                            if (this.orderItems[i].isPromo && (this.orderItems[i].fromitemNo == this.editedItems[0].no)){
                                this.orderItems.splice(i, 1);
                            } else {
                                i++;
                            }
                        }        
                        this.commitToCart(this.editedItems[0],false);   
                    }            
                    if (closeDialog) this.dialog = false;
                    if (callback) callback();
                }
            });
            if (!ok) return;
            
        },   
        deleteItem (item) {
            const index = this.orderItems.indexOf(item);            
            const indexSame = this.sameNoItems.indexOf(item);   
            if (confirm('¿Desea eliminar el producto? No se puede deshacer')){
                this.orderItems.splice(index, 1);                
                this.sameNoItems.splice(indexSame, 1);
                this.sameNoItemsBackup.splice(indexSame, 1);
            }
        },
        addNew(){            
            //Deep copy
            var newline = JSON.parse(JSON.stringify(this.editedItems[0]));
            newline.cantidad = 0;
            newline.precio = 0;
            newline.descuento = 0;
            newline.lote = '';
            this.editedItems.push(Object.assign({}, newline));
        },
        next(){            
            if (this.editedIndex+1 < this.items.length){                
                this.openDialog(this.items[this.editedIndex+1])
            }
        },
        previous(){
            if (this.editedIndex-1 >= 0){                
                this.openDialog(this.items[this.editedIndex-1])
            }
        }
    },   
    watch:{
        dialog: function(val, oldVal){
            if (!oldVal && val /*&& (this.$store.state.usuario.type == 'Comercial')*/){
                this.getExpectedReceiptDateLocal(this.editedItems[0]);
            }
        }
    },
    computed: {    
        errors:{
            get(){
                return errors.first('dto');
            }
        },
        items:{
            get(){
                return this.$store.state.items;
            },
            set(value){
                this.$store.commit('setItems',value);
            }
        },
        orderItems: {
            get(){
                return this.$store.state.orderItems;
            },
            set(value){
                this.$store.commit('setOrderItems',value)
            }
        },
        dialog:{
            get(){
                return this.$store.state.dialogEditItem;
            },
            set(value){
                this.$store.state.dialogEditItem = value;
            }
        },
        dialogData:{
            get(){
                return this.$store.state.dialogData;
            },
            set(value){
                this.$store.state.dialogData = value;
            }
        },
        editedItems:{
            get(){
                return this.$store.state.editedItems;
            },
            set(value){
                this.$store.state.editedItems = value;
            }
        },
        editedIndex:{
            get(){
                return this.$store.state.editedIndex;
            },
            set(value){
                this.$store.state.editedIndex = value;
            }
        },
        sameNoItems:{
            get(){
                return this.$store.state.sameNoItems;
            },
            set(value){
                this.$store.state.sameNoItems = value;
            }
        },        
        sameNoItemsBackup:{
            get(){
                return this.$store.state.sameNoItemsBackup;
            },
            set(value){
                this.$store.state.sameNoItemsBackup = value;
            }
        },
        available:{
            get(){
                return this.$store.state.Available;
            }
        },
        totalAvailable:{
            get(){
                var total = 0;
                this.$store.state.Available.forEach(av => {
                    //if (av.location == this.$store.state.usuario.locationCode)
                        total += av.QtyAvailable;
                });
                return total.toFixed(2);
            }
        },
        availabilityListVisible: {
            get(){
                return this.$store.state.availabilityListVisible;
            },
            set(value){
                this.$store.state.availabilityListVisible = value;
            }
        },
    } 
}
</script>
<style scoped>
li {
    list-style-type: none;
}
.btnright{
    position: absolute;
    top: 40%;
    right: 0;
    z-index: 100;
}
.btnleft{
    position: absolute;
    top: 40%;    
    z-index: 100;
}
.bold-text{
    font-weight: bold;
}
.available{
    color: green;
}
.nostock{
    color: red;
}
</style>